import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  equipmentLength: 0,
  equipment: [],
  sociedad:[],
}

export default function equipmentReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_EQUIPMENT:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADER_EQUIPMENT:
      return {...state, saveLoader: action.payload}
    case actions.GET_EQUIPMENT:
      return {...state, equipment: action.payload.equipment, equipmentLength: action.payload.equipmentLength, sociedad: action.payload.sociedad}
    default:
      return state
  }
}